module.exports = __webpack_public_path__ + "static/media/bg-login.d678930a.png";